/**
 * System event symbols, used internally for identifying events uniquely.
 */
const SYSTEM_EVENTS = {
    ON_INIT_COMPLETE              : 'ON_INIT_COMPLETE',
    ON_ORBIT_INIT_COMPLETE        : 'ON_ORBIT_INIT_COMPLETE',
    RUN_AUTOLOGIN                 : 'RUN_AUTOLOGIN',
    RUN_AUTOLOGIN_TOUCH_ID        : 'RUN_AUTOLOGIN_TOUCH_ID',
    MESSAGE_OPEN                  : 'MESSAGE_OPEN',
    MESSAGE_CLOSE                 : 'MESSAGE_CLOSE',
    ON_BEFORE_OAUTH_STATE_CHANGE  : 'ON_BEFORE_OAUTH_STATE_CHANGE',
    OAUTH_STATE_CHANGE            : 'OAUTH_STATE_CHANGE',
    AUTOLOGIN_SUCCESS             : 'AUTOLOGIN_SUCCESS',
    AUTOLOGIN_FAILED              : 'AUTOLOGIN_FAILED',
    SUCCESSFULLY_LOGIN_RESPONSE   : 'SUCCESSFULLY_LOGIN_RESPONSE',
    ON_RUN_AUTOLOGIN              : 'ON_RUN_AUTOLOGIN',
    FAIL_LOGIN_RESPONSE           : 'FAIL_LOGIN_RESPONSE',
    CLOSE_GAME                    : 'CLOSE_GAME',
    LOGIN_FORM_OPEN               : 'LOGIN_FORM_OPEN',
    LOGIN_FORM_CLOSE              : 'LOGIN_FORM_CLOSE',
    GET_NEW_TOUCH_TOKEN           : 'GET_NEW_TOUCH_TOKEN',
    SCREEN_CHANGE_STATE           : 'SCREEN_CHANGE_STATE',
    POST_MESSAGE_ARRIVE           : 'POST_MESSAGE_ARRIVE',
    HYBRID_POST_MESSAGE_ARRIVE    : 'HYBRID_POST_MESSAGE_ARRIVE',
    EXTEND_USER_TIME_TO_LIVE      : 'EXTEND_USER_TIME_TO_LIVE',
    SCREEN_RESIZE_CHANGED         : 'SCREEN_RESIZE_CHANGED',
    GAME_OPEN                     : 'GAME_OPEN',
    OPEN_GAME_ERROR               : 'OPEN_GAME_ERROR',
    FULL_SCREEN_CHANGE            : 'FULL_SCREEN_CHANGE',
    OPEN_OVERLAY                  : 'OPEN_OVERLAY',
    CLOSE_OVERLAY                 : 'CLOSE_OVERLAY',
    CLOSE_ALL_OVERLAY             : 'CLOSE_ALL_OVERLAY',
    EXTERNAL_LINK_OPEN            : 'EXTERNAL_LINK_OPEN',
    EXTERNAL_LINK_CLOSED          : 'EXTERNAL_LINK_CLOSED',
    EXTERNAL_LINK_OPENED          : 'EXTERNAL_LINK_OPENED',
    APP_RESUMED                   : 'APP_RESUMED',
    APP_PAUSED                    : 'APP_PAUSED',
    ANALYTIC_TRIGGER_ACTIVATED    : 'ANALYTIC_TRIGGER_ACTIVATED',
    ANALYTIC_DATA_LAYER_UPDATE    : 'ANALYTIC_DATA_LAYER_UPDATE',
    ANALYTICS_EXPERIMENT_ACTIVATED: 'ANALYTICS_EXPERIMENT_ACTIVATED',
    ANALYTICS_OPTIMIZE_TRIGGER    : 'ANALYTICS_OPTIMIZE_TRIGGER',
    INCOMING_MARKETING_DATA       : 'INCOMING_MARKETING_DATA',
    INCOMING_MARKETING_FLOW       : 'INCOMING_MARKETING_FLOW',
    CONVERSION_PRE_LOGIN_EVENT    : 'CONVERSION_PRE_LOGIN_EVENT',
    CONVERSION_POST_LOGIN_EVENT   : 'CONVERSION_POST_LOGIN_EVENT',
    PLAYER_ACTION: 'PLAYER_ACTION',

    BALANCE_UPDATED: 'BALANCE_UPDATED',
    CURRENCY_UPDATED: 'CURRENCY_UPDATED',
    RECENTLY_PLAYED_GAMES_UPDATED: 'RECENTLY_PLAYED_GAMES_UPDATED',
    LIVE_FEEDS_LATEST_WINNERS_UPDATED: 'LIVE_FEEDS_LATEST_WINNERS_UPDATED',
    LIVE_FEEDS_WINNINGS_UPDATED: 'LIVE_FEEDS_WINNINGS_UPDATED',
    LIVE_FEEDS_TOTAL_JACKPOTS_UPDATED: 'LIVE_FEEDS_TOTAL_JACKPOTS_UPDATED',
    LIVE_FEEDS_JACKPOT_AMOUNTS_UPDATED: 'LIVE_FEEDS_JACKPOT_AMOUNTS_UPDATED',
    LIVE_FEEDS_STATE_JACKPOTS_UPDATED: 'LIVE_FEEDS_STATE_JACKPOTS_UPDATED',
    OMG_AWAITING_MESSAGES_UPDATED: 'OMG_AWAITING_MESSAGES_UPDATED',
    OMG_OPEN_AWAITING_MESSAGES: 'OMG_OPEN_AWAITING_MESSAGES',
    OAUTH_REMOVE_FROM_LOCAL_STORAGE: 'SYSTEM_EVENTS.OAUTH_REMOVE_FROM_LOCAL_STORAGE',
    LOCAL_STORAGE_CHANGED: 'LOCAL_STORAGE_CHANGED',
    ELEMENT_CREATED: 'ELEMENT_CREATED',
    FREE_PLAY_UPDATED: 'FREE_PLAY_UPDATED',
    FREE_PLAY_VOUCHER_REMOVED: 'FREE_PLAY_VOUCHER_REMOVED',
    FREE_PLAY_OPEN_VOUCHERS_MSG: 'FREE_PLAY_OPEN_VOUCHERS_MSG',
    RESIZE_FORM: 'RESIZE_FORM',
    BEGIN_LOGIN_AFTER_REGISTRATION: 'BEGIN_LOGIN_AFTER_REGISTRATION',
    LOGIN_COMPLETED_AFTER_REGISTERATION: 'LOGIN_COMPLETED_AFTER_REGISTERATION',
    LOGIN_FAILED_AFTER_REGISTRATION: 'LOGIN_FAILED_AFTER_REGISTRATION',
    REGISTRATION_COMPLETED: 'REGISTRATION_COMPLETED',
    DETACH_REGISTER_EVENT: 'DETACH_REGISTER_EVENT',
    FREE_PLAY_VOUCHER_MSG_OPENED: 'FREE_PLAY_VOUCHER_MSG_OPENED',
    FREE_PLAY_OPEN_INTERNAL_VOUCHERS_MESSAGE: 'FREE_PLAY_OPEN_INTERNAL_VOUCHERS_MESSAGE',
    TOAST_CREATED: 'TOAST_CREATED',
    TOAST_SHOW: 'TOAST_SHOW',
    TOAST_HIDE: 'TOAST_HIDE',
    TOAST_CLOSE_BUTTON: 'TOAST_CLOSE_BUTTON',
    TOAST_USER_DISMISS: 'USER_DISMISSED_TOAST',
    HYBRID_ALERT: 'HYBRID_ALERT',
    HYBRID_OPEN_MAIL: 'HYBRID_OPEN_MAIL',
    HYBRID_UPDATE_INFO_KEY : 'HYBRID_UPDATE_INFO_KEY',
    FIREBASE_GOT_NEW_TOKEN: 'FIREBASE_GOT_NEW_TOKEN',
    TOUCH_ID_GET_TOKEN_FROM_SRV: 'TOUCH_ID_GET_TOKEN_FROM_SRV',
    TOUCH_ID_INIT_SCREEN_SHOW: 'TOUCH_ID_INIT_SCREEN_SHOW',
    TOUCH_ID_TRY_AGAIN_SKIP: 'TOUCH_ID_TRY_AGAIN_SKIP',
    TOUCH_ID_CHECK_TOKEN_ENABLE: 'TOUCH_ID_CHECK_TOKEN_ENABLE',
    TOUCH_ID_TOKEN_ENABLE_RES: 'TOUCH_ID_TOKEN_ENABLE_RES',
    TOUCH_ID_CLEAR_TOKEN: 'TOUCH_ID_CLEAR_TOKEN',
    TOUCH_ID_NATIVE_CANCEL: 'TOUCH_ID_NATIVE_CANCEL',
    TOUCH_ID_LOGIN_ERROR: 'TOUCH_ID_LOGIN_ERROR',
    TOUCH_ID_AUTO_LOGIN: 'TOUCH_ID_AUTO_LOGIN',
    TOUCH_ID_STATE_CHANGED: 'TOUCH_ID_STATE_CHANGED',
    WEB_VIEW_NAVIGATE_GAME: 'WEB_VIEW_NAVIGATE_GAME',
    WEB_VIEW_NAVIGATE_DEPOSIT_WIDGET: 'WEB_VIEW_NAVIGATE_DEPOSIT_WIDGET',
    WEB_VIEW_NAVIGATE_CASHIER: 'WEB_VIEW_NAVIGATE_CASHIER',
    SECOND_WEB_VIEW_OLD_CALL: 'SECOND_WEB_VIEW_OLD_CALL',
    SECOND_WEB_VIEW_CLOSE: 'SECOND_WEB_VIEW_CLOSE',
    SECOND_WEB_VIEW_OPEN: 'SECOND_WEB_VIEW_OPEN',
    SECOND_WEB_VIEW_CLOSE_ALL: 'SECOND_WEB_VIEW_CLOSE_ALL',
    MINI_CASHIER_HEIGHT_CHANGED: 'MINI_CASHIER_HEIGHT_CHANGED',
    CONTENT_LOADED: 'CONTENT_LOADED',
    OVERLAY_OPEN_AWAIT: 'OVERLAY_OPEN_AWAIT',
    OVERLAY_CLOSE_EXPIRED: 'OVERLAY_CLOSE_EXPIRED',
	INTERNAL_URL_NAVIGATION: 'INTERNAL_URL_NAVIGATION',
    FABRIC_ADD_EVENT : 'FABRIC_ADD_EVENT',
    ADD_TAG_OPEN_APP_VER : 'ADD_TAG_OPEN_APP_VER',
    ADD_TAG : 'ADD_TAG',
    REM_TAG : 'REM_TAG',
    DEEPLINK_RECEIVED: 'DEEPLINK_RECEIVED',
    WEB_LOGIN_OPEN_REGISTER: 'WEB_LOGIN_OPEN_REGISTER',
    ROUTE_CHANGED: 'ROUTE_CHANGED',
    RESTRICTIONS_CHANGED: 'RESTRICTIONS_CHANGED',
    SESSION_TIMER_UPDATE: 'SESSION_TIMER_UPDATE',
    WINDOW_FOCUS_GAIN: 'WINDOW_FOCUS_GAINED',
    WINDOW_FOCUS_LOSS: 'WINDOW_FOCUS_LOST',
    GEO_HYBRID_UPDATE_ENABLE : 'GEO_HYBRID_UPDATE_ENABLE',
    GEO_HYBRID_GT_CB : 'GEO_HYBRID_GT_CB',
    GEO_HYBRID_GET_LOCATION : 'GEO_HYBRID_GET_LOCATION',
    GEO_HYBRID_GET_LOCATION_RES : 'GEO_HYBRID_GET_LOCATION_RES',
    GEO_LOCATION_FAILED : 'GEO_LOCATION_FAILED',
    GEO_LOCATION_SUCCEED: 'GEO_LOCATION_SUCCEED',
    GEO_KICK_EVENT: 'GEO_KICK_EVENT',
    SESSION_EVENT_KICK: 'SESSION_EVENT_KICK',
    SESSION_EVENT_WALLET: 'SESSION_EVENT_WALLET',
    SESSION_EVENT_OMG_RECEIVED: 'SESSION_EVENT_OMG_RECEIVED',
	SESSION_EVENT_FREE_PLAY_RECEIVED: 'SESSION_EVENT_FREE_PLAY_RECEIVED', //TODO - obsolete. This should be removed once free play from SDK will be removed
    SESSION_EVENT_FREE_PLAY_REMOVED: 'SESSION_EVENT_FREE_PLAY_REMOVED',
    SESSION_EVENT_FREE_PLAY_BATCH_ADDED: 'SESSION_EVENT_FREE_PLAY_BATCH_ADDED',
    SESSION_EVENT_FREE_PLAY_BATCH_UPDATED: 'SESSION_EVENT_FREE_PLAY_BATCH_UPDATED',
    SESSION_EVENT_FREE_PLAY_BATCH_REMOVED: 'SESSION_EVENT_FREE_PLAY_BATCH_REMOVED',
	SESSION_EVENT_THIRD_PARTY_FREE_PLAY_UPDATED: 'SESSION_EVENT_THIRD_PARTY_FREE_PLAY_UPDATED',
	SESSION_EVENT_NET_POSITION_UPDATE: 'SESSION_EVENT_NET_POSITION_UPDATE',
    SESSION_EVENT_RECEIVED_TOASTER: 'SESSION_EVENT_RECEIVED_TOASTER',
    SESSION_EVENT_UPDATERESTRICTION_RECEIVED: 'SESSION_EVENT_UPDATERESTRICTION_RECEIVED',
    SESSION_EVENT_PLAYER_BURNOUT_MESSAGE_RECEIVED: 'SESSION_EVENT_PLAYER_BURNOUT_MESSAGE_RECEIVED',
    NET_POSITION_VALUE_UPDATE: 'NET_POSITION_VALUE_UPDATE',
    SECOND_WEB_VIEW_NAVIGATE_SPORT: 'SECOND_WEB_VIEW_NAVIGATE_SPORT',
    TIME_UPDATED_FROM_SERVER: 'TIME_UPDATED_FROM_SERVER',
    ON_BROWSER_PAGE_HIDE: 'ON_BROWSER_PAGE_HIDE',
	TOKEN_LIFETIME_EXPIRED: 'TOKEN_LIFETIME_EXPIRED',
	LIVE_TABLES_UPDATE: 'LIVE_TABLES_UPDATE',
    LOADING_INDICATOR_EMBEDDED_UPDATE: 'LOADING_INDICATOR_EMBEDDED_UPDATE',
    LOADING_INDICATOR_EMBEDDED_UPDATE_V2: 'LOADING_INDICATOR_EMBEDDED_UPDATE_V2',
    LOADING_INDICATOR_EMBEDDED_CLOSED_BY_X: 'LOADING_INDICATOR_EMBEDDED_CLOSED_BY_X',
    BLUE_RIBBON_PERSONAL_JP_STATE_CHANGED: 'BLUE_RIBBON_PERSONAL_JP_STATE_CHANGED',
    BLUE_RIBBON_PARTY_JP_STATE_CHANGED: 'BLUE_RIBBON_PARTY_JP_STATE_CHANGED',
    BLUE_RIBBON_PARTY_JACKPOT_WIN: 'BLUE_RIBBON_PARTY_JACKPOT_WIN',
    BLUE_RIBBON_PARTY_JACKPOT_INSUFFICIENT_MONEY: 'BLUE_RIBBON_PARTY_JACKPOT_INSUFFICIENT_MONEY',
    BLUE_RIBBON_CONNECTION_COMPLETE: 'BLUE_RIBBON_CONNECTION_COMPLETE',
    BLUE_RIBBON_IS_ENABLED_CHANGED: 'BLUE_RIBBON_IS_ENABLED_CHANGED',
    GAMES_QUESTIONNAIRE_COMPLETED: 'GAMES_QUESTIONNAIRE_COMPLETED',
    GAME_SEQUENCE_FINISH: 'GAME_SEQUENCE_FINISH',
    GAME_POPUP_SHOW: 'GAME_POPUP_SHOW',
    USER_APPROVE_GAME_POPUP: 'USER_APPROVE_GAME_POPUP',
    BONUS_ABUSE_PARKING_MONEY : 'BONUS_ABUSE_PARKING_MONEY',
    SHOW_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW : 'SHOW_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW',
    CLOSE_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW : 'CLOSE_POPUP_ABOVE_HYBRID_SECOND_WEB_VIEW',
    DEPOSIT_WIDGET_CLOSED : 'DEPOSIT_WIDGET_CLOSED',
    DAILY_DEAL_REMOVE_INDICATION: 'DAILY_DEAL_REMOVE_INDICATION',
    LOCATION_POPUP_OPEN         : 'LOCATION_POPUP_OPEN',
    LOCATION_POPUP_CLOSED       : 'LOCATION_POPUP_CLOSED',
    PLAYER_MESSAGES_STRATEGY_READY: 'PLAYER_MESSAGES_STRATEGY_READY',
    CHANGE_OVERLAY_PRIORITY: 'CHANGE_OVERLAY_PRIORITY',
    OMG_DISPLAYED: 'OMG_DISPLAYED',
    LIVE_GAME_SWITCHED: 'LIVE_GAME_SWITCHED',
    PROMOTIONS_CHANGED: 'PROMOTIONS_CHANGED',
    ODR_CLEAR_ALL_GAMES: 'ODR_CLEAR_ALL_GAMES'
};

/**
 * Client event symbols, used internally for identifying events uniquely.
 */
const CLIENT_EVENTS = {
    MENU_CLICKED: 'MENU_CLICKED',
    LOGIN_BUTTON_CLICKED: 'LOGIN_BUTTON_CLICKED',
    REALITY_CHECK_OPENED: 'REALITY_CHECK_OPENED',
    REALITY_CHECK_CLOSED: 'REALITY_CHECK_CLOSED'
};

const USER_EVENTS = {
    ON_CLICK: 'click',
    ON_DOUBLE_CLICK: 'dblclick',
    ON_SUBMIT: 'submit',
    ON_MOUSE_MOVE: 'mousemove',
    ON_MOUSE_DOWN: 'mousedown',
    ON_KEY_PRESS: 'keypress',
    ON_DOM_MOUSE_SCROLL: 'DOMMouseScroll',
    ON_MOUSE_WHEEL: 'mousewheel',
    ON_TOUCH_START: 'touchstart',
    ON_TOUCH_MOVE: 'touchmove',
    ON_TOUCH_END: 'touchend',
    ON_MSPOINTER_MOVE: 'MSPointerMove',
    ON_RESIZE: 'resize',
    ON_FOCUS: 'focus',
    ON_CHANGE: 'change',
    ON_BLUR: 'blur'
};

const USER_ACTIVITY_EVENTS_ALL = [
    SYSTEM_EVENTS.MESSAGE_CLOSE,
    SYSTEM_EVENTS.FULL_SCREEN_CHANGE,
    SYSTEM_EVENTS.CLOSE_OVERLAY,
    SYSTEM_EVENTS.CLOSE_ALL_OVERLAY,
    SYSTEM_EVENTS.APP_RESUMED,
    SYSTEM_EVENTS.PLAYER_ACTION,
    SYSTEM_EVENTS.TOAST_USER_DISMISS,
    SYSTEM_EVENTS.OMG_OPEN_AWAITING_MESSAGES,
    SYSTEM_EVENTS.FREE_PLAY_VOUCHER_MSG_OPENED,
    SYSTEM_EVENTS.BALANCE_UPDATED,
	SYSTEM_EVENTS.EXTEND_USER_TIME_TO_LIVE,
    SYSTEM_EVENTS.GAME_OPEN,
    SYSTEM_EVENTS.CLOSE_GAME
];

/**
 * we need this because app resume in hybrid poker nj happen every few minutes because they save the screen open.
 * so the user will ever have inactivity kick.
 * @type {[string,string,string,string,string,string,string,string,string,string]}
 */
const USER_ACTIVITY_EVENTS_FOR_HYBRID = [
    SYSTEM_EVENTS.MESSAGE_CLOSE,
    SYSTEM_EVENTS.FULL_SCREEN_CHANGE,
    SYSTEM_EVENTS.CLOSE_OVERLAY,
    SYSTEM_EVENTS.CLOSE_ALL_OVERLAY,
    SYSTEM_EVENTS.PLAYER_ACTION,
    SYSTEM_EVENTS.TOAST_USER_DISMISS,
    SYSTEM_EVENTS.OMG_OPEN_AWAITING_MESSAGES,
    SYSTEM_EVENTS.FREE_PLAY_VOUCHER_MSG_OPENED,
    SYSTEM_EVENTS.BALANCE_UPDATED,
    SYSTEM_EVENTS.EXTEND_USER_TIME_TO_LIVE,
    SYSTEM_EVENTS.GAME_OPEN,
    SYSTEM_EVENTS.CLOSE_GAME,
    SYSTEM_EVENTS.POST_MESSAGE_ARRIVE
];

export {SYSTEM_EVENTS, CLIENT_EVENTS, USER_EVENTS, USER_ACTIVITY_EVENTS_ALL, USER_ACTIVITY_EVENTS_FOR_HYBRID};